"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CA_RULES = void 0;
const saaThresholds_1 = require("encamp-shared/dist/constants/saaThresholds");
/**
 * California (DTSC) accumulation rules. CA defines its own VSQG tier at 22
 * CCR 66262.13 but never adopted the federal VSQG accumulation relief, so a
 * CA VSQG must still meet SQG-level accumulation limits — for this engine's
 * purposes CA effectively has no VSQG tier: whichever of the federal status
 * and CA's own SQG/LQG determination is MORE stringent sets the central
 * clock. Every rule here therefore matches on generatorStatus "ANY" and
 * picks its tier through effectiveCaStatus instead of the federal-status
 * field the base engine filters on.
 */
const CA_STATUS_RANK = {
    LQG: 3,
    SQG: 2,
    VSQG: 1,
};
function effectiveCaStatus(ctx) {
    const candidates = [ctx.generatorStatus, ctx.stateGeneratorStatus].filter((status) => status !== null);
    if (candidates.length === 0) {
        return null;
    }
    return candidates.reduce((mostStringent, status) => CA_STATUS_RANK[status] > CA_STATUS_RANK[mostStringent] ? status : mostStringent);
}
exports.CA_RULES = [
    {
        id: "CA_CENTRAL_LQG",
        scope: "CA",
        areaType: "CENTRAL",
        generatorStatus: "ANY",
        limit: { kind: "TIME", days: 90 },
        citation: "22 CCR 66262.17(a)",
        condition: (ctx) => effectiveCaStatus(ctx) === "LQG",
    },
    {
        id: "CA_CENTRAL_SQG",
        scope: "CA",
        areaType: "CENTRAL",
        generatorStatus: "ANY",
        limit: { kind: "TIME", days: 180 },
        citation: "22 CCR 66262.16(b)",
        // The 200-mile exception (below) supersedes this default when it applies.
        condition: (ctx) => effectiveCaStatus(ctx) === "SQG" && !ctx.sqgOver200Miles,
    },
    {
        id: "CA_CENTRAL_SQG_200MI",
        scope: "CA",
        areaType: "CENTRAL",
        generatorStatus: "ANY",
        limit: { kind: "TIME", days: 270 },
        citation: "22 CCR 66262.16(c)",
        condition: (ctx) => effectiveCaStatus(ctx) === "SQG" && ctx.sqgOver200Miles,
    },
    // Same numeric volume thresholds as federal (22 CCR 66262.15(a) sets the
    // same 55 gal / 1 qt / 1 kg figures 40 CFR 262.15 does), but under CA's
    // own regulation and WITHOUT the federal VSQG carve-out: CA has no VSQG
    // relief, so satellite limits reach facilities the federal rule exempts.
    {
        id: "CA_SATELLITE",
        scope: "CA",
        areaType: "SATELLITE",
        generatorStatus: "ANY",
        limit: {
            kind: "VOLUME",
            nonAcuteGal: saaThresholds_1.SAA_NON_ACUTE_VOLUME_LIMIT_GAL,
            acuteGal: saaThresholds_1.SAA_ACUTE_VOLUME_LIMIT_GAL,
            acuteKg: saaThresholds_1.SAA_ACUTE_MASS_LIMIT_KG,
            moveWindowDays: saaThresholds_1.SATELLITE_MOVE_WINDOW_DAYS,
        },
        citation: "22 CCR 66262.15(a)",
    },
    // CA's satellite addition federal law has no analog for: full-or-one-year,
    // whichever comes first. The volume rule above covers "full"; this covers
    // the year, anchored (like every satellite TIME limit) to the container's
    // accumulation start date.
    {
        id: "CA_SATELLITE_ONE_YEAR",
        scope: "CA",
        areaType: "SATELLITE",
        generatorStatus: "ANY",
        limit: { kind: "TIME", days: 365 },
        citation: "22 CCR 66262.15(a)(9)",
    },
];
//# sourceMappingURL=CA.js.map